export { ENVIRONMENTS } from "../../../serverConfig"; // TODO: remove and fix import for other files

export const MD_BREAKPOINT = 768;

export const INPUT_COMPONENT_DEBOUNCE_TIMESPAN = 1000;

export const NO_DATA_VALUE = "–";

export const ROWS_PER_PAGE_OPTIONS = [25, 50, 100];
export const DEFAULT_ROWS = ROWS_PER_PAGE_OPTIONS[0];

export const SORT = Object.freeze({
    ASC: 1,
    NONE: 0,
    DESC: -1,
});

export const SORT_LABELS = Object.freeze({
    ASC: "asc",
    DESC: "desc",
});

export const START_OF_DAY_TIME = "00:00";
export const END_OF_DAY_TIME = "23:59";
export const START_OF_DAY_TIME_BE = "00:00:00";
export const END_OF_DAY_TIME_BE = "23:59:59";
export const DATE_FORMAT = "DD.MM.YYYY";
export const DATE_FORMAT_SHORT_YEAR = "DD.MM.YY";
export const DATE_TIME_FORMAT = "DD.MM.YYYY HH:mm";
export const DATE_TIME_FORMAT_WITH_SECONDS = "DD.MM.YYYY HH:mm:ss";
export const TIME_FORMAT = "HH:mm";

export const WEEK_DAYS = Object.freeze({
    ALL: "ALL",
    MONDAY: "MONDAY",
    TUESDAY: "TUESDAY",
    WEDNESDAY: "WEDNESDAY",
    THURSDAY: "THURSDAY",
    FRIDAY: "FRIDAY",
    SATURDAY: "SATURDAY",
    SUNDAY: "SUNDAY",
} as const);

export const BARCODE_FORMATS = {
    AZTEC: "aztec",
    CODE_128: "code_128",
    CODE_39: "code_39",
    CODE_93: "code_93",
    CODABAR: "codabar",
    DATABAR: "databar",
    DATABAR_EXPANDED: "databar_expanded",
    DATA_MATRIX: "data_matrix",
    DX_FILM_EDGE: "dx_film_edge",
    EAN_13: "ean_13",
    EAN_8: "ean_8",
    ITF: "itf",
    MAXI_CODE: "maxi_code",
    MICRO_QR_CODE: "micro_qr_code",
    PDF417: "pdf417",
    QR_CODE: "qr_code",
    RM_QR_CODE: "rm_qr_code",
    UPC_A: "upc_a",
    UPC_E: "upc_e",
    LINEAR_CODES: "linear_codes",
    MATRIX_CODES: "matrix_codes",
    UNKNOWN: "unknown",
};
